import React from "react"
import { PremiumEpisodeLabel } from "../LastPage/RecommendedEpisodes/PremiumEpisode"

const EpisodeMediaObj = ({
  episode: { cover_url, title, price, paid, premium },
  texts: { unlockedText, freeText },
  path,
  disableThumb = false
}) => (
  <a href={path} className="db text-decoration-none black">
    <div className="flex items-center t-pv1 t-ph2">
      {!disableThumb && (
        <div className="t-mr2">
          <img
            className="db"
            src={cover_url}
            alt={`Cover of ${title}`}
            width="46px"
            height="46px"
          />
        </div>
      )}
      <div className="lh-title">
        <p className="truncate t-mt0 t-mb1" style={{ maxWidth: "11rem" }}>
          {title}
        </p>
        {premium && (
          <PremiumEpisodeLabel
            price={price}
            paid={paid}
            unlockedText={unlockedText}
            freeText={freeText}
            className="fw3 black"
          />
        )}
      </div>
    </div>
  </a>
)

export default EpisodeMediaObj
